import api from "./client";
import type {
  MaterialRequest,
  MaterialRequestFormData,
  MaterialRequestStatus,
} from "../types";

export interface MaterialRequestListParams {
  project_id?: number;
  status?: MaterialRequestStatus;
  stock_item_id?: number;
  per_page?: number;
}

// ---- Malzeme talepleri CRUD ----

/** Talep önce sıralı liste (backend STATUS_ORDER). Varsayılan 100 kayıt çeker. */
export async function fetchMaterialRequests(
  params?: MaterialRequestListParams,
): Promise<MaterialRequest[]> {
  const response = await api.get("/api/v1/material-requests", {
    params: { per_page: 100, ...params },
  });
  return response.data.data;
}

export async function createMaterialRequest(
  data: MaterialRequestFormData,
): Promise<MaterialRequest> {
  const response = await api.post("/api/v1/material-requests", data);
  return response.data.data;
}

/** Alan güncelleme — yalnızca talep durumundayken (aksi halde backend 422). */
export async function updateMaterialRequest(
  requestId: number,
  data: Partial<Pick<MaterialRequestFormData, "quantity" | "needed_by" | "notes">>,
): Promise<MaterialRequest> {
  const response = await api.put(`/api/v1/material-requests/${requestId}`, data);
  return response.data.data;
}

export async function deleteMaterialRequest(requestId: number): Promise<void> {
  await api.delete(`/api/v1/material-requests/${requestId}`);
}

// ---- Durum geçiş aksiyonları ----

export async function approveMaterialRequest(requestId: number): Promise<MaterialRequest> {
  const response = await api.post(`/api/v1/material-requests/${requestId}/approve`);
  return response.data.data;
}

export async function rejectMaterialRequest(
  requestId: number,
  rejectionReason: string,
): Promise<MaterialRequest> {
  const response = await api.post(`/api/v1/material-requests/${requestId}/reject`, {
    rejection_reason: rejectionReason,
  });
  return response.data.data;
}

export async function markMaterialRequestOrdered(requestId: number): Promise<MaterialRequest> {
  const response = await api.post(`/api/v1/material-requests/${requestId}/mark-ordered`);
  return response.data.data;
}

export async function markMaterialRequestShipped(requestId: number): Promise<MaterialRequest> {
  const response = await api.post(`/api/v1/material-requests/${requestId}/mark-shipped`);
  return response.data.data;
}

/** Teslim alma — aynı transaction içinde stok kartına giris hareketi yazılır. */
export async function receiveMaterialRequest(requestId: number): Promise<MaterialRequest> {
  const response = await api.post(`/api/v1/material-requests/${requestId}/receive`);
  return response.data.data;
}

// ---- e-Belge: irsaliye eşleştirme + irsaliyesiz teslim uyarıları ----

/**
 * Teslim alınan talebe irsaliye masraf kaydını bağlar/kaldırır.
 * `expenseId` null ise bağlantı kaldırılır. Masraf irsaliye tipinde ve
 * aynı projede olmalı (aksi 422).
 */
export async function linkMaterialRequestIrsaliye(
  requestId: number,
  expenseId: number | null,
): Promise<MaterialRequest> {
  const response = await api.patch(`/api/v1/material-requests/${requestId}/irsaliye`, {
    expense_id: expenseId,
  });
  return response.data.data;
}

/** Teslim alınmış ama irsaliye bağlanmamış talepler (irsaliyesiz mal girişi). */
export async function fetchDeliveryWarnings(params?: {
  project_id?: number;
}): Promise<MaterialRequest[]> {
  const response = await api.get("/api/v1/material-requests/delivery-warnings", { params });
  return response.data.data;
}
